var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.worthless && _vm.isDistributor)?_c('div',{staticClass:"disProfit"},[_c('span',{staticClass:"disProfit__label"},[_vm._v("利润")]),_vm._v(" "),_c('span',{staticClass:"disProfit__content"},[_vm._v(_vm._s(_vm.profitText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }